var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48.725mm",
    height: "60.906mm",
    viewBox: "0 0 48.725 60.906",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-34.851 -94.409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m59.214 94.409c-12.79 0-24.362 9.8058-24.362 24.971 0 10.11 8.131 22.078 24.362 35.934 16.231-13.856 24.362-25.824 24.362-35.934 0-15.166-11.572-24.971-24.362-24.971zm-0.28556 23.886c-3.3498 0 0.42828 3.6591 0.42828 0.30962 0-3.3498-3.4212-0.046-0.0714-0.046 3.3498 0 0.0242-3.3261 0.0242 0.023 0 3.3498 2.9692-0.28544-0.38063-0.28544z",
    fill: "#898196",
    strokeWidth: 3.0453
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffd42a"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 53.675,
    cy: 105.72,
    r: 3.0427
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.577,
    cy: 119.22,
    r: 3.0427
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.29,
    cy: 135.36,
    r: 3.0427
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.061,
    cy: 123.19,
    r: 3.0427
  })), /*#__PURE__*/React.createElement("path", {
    d: "m46.796 123.19 6.7469-17.595 20.902 13.626-14.288 16.404z",
    fill: "none",
    stroke: "#ffd42a",
    strokeWidth: 3
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.5d408da01010b6c6b40be9c4b7084504.svg";
export { ForwardRef as ReactComponent };